import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEmployeeDetails, setEmployeeData } from "./employeeSlice";
import { fetchEntityDetail } from "~/components/global-entities/globalEntitiesSlice";

const useEditEmployee = () => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { id } = useParams();
  const { employeeDetails, isDataAvailable } = useSelector(
    (state) => state.employeeregister,
  );

  const initialLoads = async (id) => {
    setLoading(true);
    dispatch(
      setEmployeeData({
        key: "isDataAvailable",
        value: false,
      }),
    );
    try {
      const data = await dispatch(getEmployeeDetails(id));
      const entityId = data?.payload?.data?.entity_id;
      if (entityId) {
        await dispatch(fetchEntityDetail(entityId));
      }
      dispatch(
        setEmployeeData({
          key: "isDataAvailable",
          value: true,
        }),
      );
    } catch (error) {
      console.error("Failed to load employee/entity details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initialLoads(id);
  }, []);

  return {
    employeeDetails,
    initialLoads,
    loading,
    isDataAvailable,
  };
};

export default useEditEmployee;
